export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";

export function openDialog(dialogOptions) {
  return {
    type: OPEN_DIALOG,
    dialogOptions,
  };
}

export function closeDialog() {
  return {
    type: CLOSE_DIALOG,
  };
}

